// extracted by mini-css-extract-plugin
export default {"closeButton":"CloseModal_closeButton__2Wv6s","fadeIn":"CloseModal_fadeIn__tJfHG","iconShake":"CloseModal_iconShake__dTSEu"};